import "./digital-assets-filters-toggle.scss";
import EventClass from "common/utils/ui/event-class";

export default props =>
  new EventClass({
    eventSelector: ".js-digital-assets-filters-toggle",
    ...props
  });
